export enum DesignerMode {
  None = 0,
  Cover = 2,
  FrontMatter = 1,
}
